module.exports = __webpack_public_path__ + "static/media/lars_birkholm_petersen.6127d132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/collections/altolans/images/lars_birkholm_petersen.jpg
// module id = 992
// module chunks = 0